import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/account",
    children: [
      {
        name: "account-roles",
        path: "roles",
        component: () => import("../presentation/pages/Roles.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list",
          subject: "role",
        },
      },
      {
        name: "account-invites",
        path: "invites",
        component: () => import("../presentation/pages/Invites.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list",
          subject: "user_invite",
        },
      },
      {
        name: "account-users",
        path: "users",
        component: () => import("../presentation/pages/UserAccounts.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list",
          subject: "user",
        },
      },
      {
        name: "account-subordinate-users",
        path: "subordinate-users",
        component: () => import("../presentation/pages/SubordinateUsers.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list",
          subject: "user",
        },
      },
      {
        name: "account-all-users",
        path: "all-users",
        component: () => import("../presentation/pages/AllUsers.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list_all",
          subject: "user",
        },
      },
      {
        name: "account-user-details",
        path: "users/:id",
        component: () => import("../presentation/pages/UserDetails.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "view",
          subject: "user",
        },
      },
      {
        name: "account-all-invites",
        path: "all-invites",
        component: () => import("../presentation/pages/AllInvites.vue"),
        meta: {
          layout: "default",
          public: false,
          action: "list_all",
          subject: "user_invite",
        },
      },
      {
        name: "account-accept-invite",
        path: "accept-invite/:token",
        component: () => import("../presentation/pages/AcceptInvite.vue"),
        meta: {
          layout: "blank",
          public: true,
        },
      },
      {
        name: "account-switch",
        path: "switch-account",
        component: () => import("../presentation/pages/SwitchAccount.vue"),
        meta: {
          layout: "default",
          public: false,
        },
      },
    ],
  },
];
